import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// API Models
export interface ApiGroup {
  id: number;
  name: string;
  code: string;
}

export interface ApiCatalogue {
  id: number;
  name: string;
  environment: string;
  method: string;
  gatewayRoute: string;
  upstreamServiceUrl: string;
  authentication: string;
  status: 'Active' | 'Draft' | 'Disabled';
  requiredScope: string;
  primaryGroup: ApiGroup;
  createdDate: string;
}

export interface ApiCatalogueRequest {
  name: string;
  environment: string;
  method: string;
  gatewayRoute: string;
  upstreamServiceUrl: string;
  primaryGroupId: number;
  authentication: string;
  status: 'Active' | 'Draft' | 'Disabled';
  requiredScope?: string;
}

export interface ApiCatalogueResponse {
  content: ApiCatalogue[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ApiCatalogueService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getApiGroups(): Observable<ApiGroup[]> {
    return this.http.get<ApiGroup[]>(
      `${this.baseUrl}/admin/api-groups`
    );
  }

  getApis(
    page = 0,
    size = 20,
    query = '',
    groupId?: number,
    status?: string
  ): Observable<ApiCatalogueResponse> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (query) {
      params = params.set('query', query);
    }
    if (groupId) {
      params = params.set('groupId', groupId);
    }
    if (status) {
      params = params.set('status', status);
    }

    return this.http.get<ApiCatalogueResponse>(
      `${this.baseUrl}/admin/api-catalogue`,
      { params }
    );
  }

  getApiById(id: number): Observable<ApiCatalogue> {
    return this.http.get<ApiCatalogue>(
      `${this.baseUrl}/admin/api-catalogue/${id}`
    );
  }

  registerApi(payload: ApiCatalogueRequest): Observable<ApiCatalogue> {
    return this.http.post<ApiCatalogue>(
      `${this.baseUrl}/admin/api-catalogue`,
      payload
    );
  }

  updateApi(id: number, payload: ApiCatalogueRequest): Observable<ApiCatalogue> {
    return this.http.put<ApiCatalogue>(
      `${this.baseUrl}/admin/api-catalogue/${id}`,
      payload
    );
  }
}